import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Auto-discovers every locales/<lang>/<namespace>.json at build time — adding a new module's
// translations is just dropping a new JSON file here, nothing else to wire.
const modules = import.meta.glob('./locales/*/*.json', { eager: true }) as Record<
  string,
  { default: Record<string, unknown> }
>;

const resources: Record<string, Record<string, Record<string, unknown>>> = {};

for (const [path, mod] of Object.entries(modules)) {
  const match = /\.\/locales\/([^/]+)\/([^/]+)\.json$/.exec(path);
  if (!match) continue;
  const [, lang, namespace] = match;
  resources[lang] ??= {};
  resources[lang][namespace] = mod.default;
}

function applyDocumentDirection(lang: string) {
  const rtlLanguages = ['ar'];
  document.documentElement.dir = rtlLanguages.includes(lang) ? 'rtl' : 'ltr';
  document.documentElement.lang = lang;
}

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    supportedLngs: Object.keys(resources),
    ns: Object.keys(resources.en ?? {}),
    defaultNS: 'common',
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'ims.language',
    },
  });

i18n.on('languageChanged', applyDocumentDirection);
applyDocumentDirection(i18n.language ?? 'en');

export default i18n;
